import {MESSAGE_TYPE_DEBUG, MESSAGE_TYPE_WARNING} from './constants';

class Logger {

    debug = window.ALMEFY_DEBUG;
    entries = [];
    logHandlers = [];

    constructor() {
        this.attachLogHandler((message, type) => {
            window.console && console[type](message);
        })
    }

    add(message, type) {
        this.entries.push({
            message: message,
            type: type
        });

        if (!this.debug && type === MESSAGE_TYPE_DEBUG) return;

        this.logHandlers.forEach((fn) => {
            fn(message, type);
        });
    }

    attachLogHandler(fn) {
        if (typeof fn === "function") {
            this.logHandlers.push(fn);
        } else {
            this.add("Parameter is not a function", MESSAGE_TYPE_WARNING);
        }
    }

    setDebug(flag = true) {
        this.debug = flag;
    }
}

const Log = new Logger();

export default Log;
